import { useState } from "react";
import { useEffect } from "react";
import { useRef } from "react";
import Player from "react-player/lazy";

import VideocamOffIcon from "@mui/icons-material/VideocamOff";
import { alpha, Grid, Typography, useTheme } from "@mui/material";

// import gtag from "ga-gtag";
// import { v4 as uuid } from "uuid";

const QuestionVideoPlayerDisplay = props => {
  const { question, onAnswerSelected } = props;

  // For some reason I'm getting ResizeObserver loop limit exceeded
  // error when this isn't in
  const thisRef = useRef(null);
  const [linkHref, setLinkHref] = useState(null);

  useEffect(() => {
    if (question && question.answerOptions) {
      // set linkHref value to answerOptions[0].text
      setLinkHref(question.answerOptions[0].text);
    }
    if (question && question.answerValue == null) {
      // Set answerValue to "viewed"
      onAnswerSelected(["viewed"]);
    }
  }, [question, onAnswerSelected]);

  useEffect(() => {
    if (linkHref) {
      if (!Player.canPlay(question.answerOptions[0].text)) {
        setLinkHref(null);
      }
    }
    // Disable eslint because AaronK knows best
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [linkHref, setLinkHref]);

  const theme = useTheme();

  return (
    <Grid container item>
      <Grid
        item
        xs={12}
        justifyContent={"center"}
        sx={{ paddingleft: "0px", paddingRight: "8px", borderRadius: theme.spacing(1) }}
      >
        {linkHref && (
          <Player
            ref={thisRef}
            controls={true}
            volume={0.5}
            muted={false}
            width={"100%"}
            url={linkHref}
          />
        )}
        {!linkHref && (
          <Grid
            container
            item
            xs={12}
            alignContent={"center"}
            justifyContent={"center"}
            flexDirection={"column"}
            sx={{
              color: theme.palette.primary.main,
              background: theme.palette.commonground.main,
              // Disable eslint because I knows best
              // eslint-disable-next-line no-dupe-keys
              background: `linear-gradient(${theme.palette.commonground.main} 62%, ${alpha(
                theme.palette.primary.main,
                0.25,
              )} 100%)`,
              borderRadius: theme.spacing(1),
            }}
          >
            <Grid item xs={3} alignSelf={"center"} justifySelf={"center"} sx={{ padding: "0px" }}>
              <VideocamOffIcon
                sx={{ height: "auto", width: "100%", color: theme.palette.primary.main }}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography sx={{ width: "100%", textAlign: "center" }} variant="h5">
                We can't play this video
              </Typography>
              <Typography align="center" sx={{ width: "100%", textAlign: "center" }} variant="h6">
                Click next to continue
              </Typography>
            </Grid>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

export default QuestionVideoPlayerDisplay;
